<template>
  <div>
    <title-edit header="Our Service" />
    <line-hr />
  <v-tabs v-model="tab">
    <v-tab key='st' href="#st">Our Service</v-tab>
    <v-tab key='nd' href="#nd">+ Detail</v-tab>
    <v-tab-item id='st'>
<!--      <div>-->
<!--        <title-edit header="Our Service" />-->
<!--        <line-hr />-->
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Title TH*</label>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-text-field :model="form.title_th" @update="updateTitleTH"/>
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Title EN*</label>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-text-field :model="form.title_en" @update="updateTitleEN"/>
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Description TH*</label>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-editor :model="form.intro_th" @update="updateDescriptionTH"/>
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Description EN*</label>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-editor :model="form.intro_en" @update="updateDescriptionEN"/>
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Path*</label>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-text-field :model="form.path" @update="updatePath"/>
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Image Illustration:</label>
            <div style="color: #2E8037; font-size: 12px">
              *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
            </div>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-image-upload
                    id="input1"
                    height="200px"
                    width="200px"
                    :error-size="'500'"
                    :model="form.image_illustration_show"
                    @update="updateImageIllust"
                    col="col-6"
            />
          </v-col>
        </div>
        <div class="row">
          <v-col cols="12" sm="3"  class="label">
            <label>Image Cover:</label>
            <div style="color: #2E8037; font-size: 12px">
              *รองรับ JPEG ,PNG ขนาดไฟล์ไม่เกิน 500KB
            </div>
          </v-col>
          <v-col cols="12" sm="8" >
            <input-image-upload
                    id="input2"
                    height="200px"
                    width="200px"
                    :error-size="'500'"
                    :model="form.image_cover_show"
                    @update="updateImageCover"
                    col="col-6"
            />
          </v-col>
        </div>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" align="center" justify="center">
            <submit-button @click.native="openSubMenu(null)" label="+ Detail" />
          </v-col>
        </v-row>
        <div class="row justify-center d-flex">
          <v-col cols="12">
            <v-simple-table class="branch-data">
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-center" v-for="header in headers" :key="header.id">
                    {{ header.text }}
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(subMenu, index) in subMenuTable" :key="subMenu.id">
                  <td align="center">{{ ++index }}</td>
                  <td>{{ subMenu.title_th }}</td>
                  <td>{{ subMenu.title_en }}</td>
                  <td>{{ subMenu.detail_th }}</td>
                  <td>{{ subMenu.detail_en }}</td>
                  <td width="150px" align="center">
                    <a @click="openSubMenu(subMenu.id)">
                      <v-icon
                              class="fas fa-pencil-alt"
                              style="color: #2E8037;font-size: 20px"
                      ></v-icon> </a
                    >&nbsp;
                    <a @click="deleteSubMenu(subMenu.id,index-1)">
                      <v-icon class="fas fa-trash" style="color: #2E8037;font-size: 20px"></v-icon>
                    </a>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-col>
          <v-col sm="2"></v-col>
        </div>
        <line-hr />
        <command-button @delete-info="deleteOurService" @save-info="saveOurService" @save-close="saveClose"></command-button>
<!--        <v-dialog v-model="dialog" scrollable width="800px">-->
<!--          <create-our-service-detail  @update="saveSubMenuDetails" />-->
<!--        </v-dialog>-->
<!--      </div>-->
    </v-tab-item>
    <v-tab-item id='nd'>
      <create-our-service-detail  @update="saveSubMenuDetails" />
    </v-tab-item>
  </v-tabs>
  </div>
</template>

<script>
    import TitleEdit from "../../components/TitleHeader/TitleEdit";
    import LineHr from "../../components/Icon/line-hr";
    import SelectOption from "../../components/Input/selectOption";
    import InputTextField from "../../components/Input/InputTextField";
    import DeleteButton from "../../components/Button/DeleteButton";
    import PreviewButton from "../../components/Button/PreviewButton";
    import SaveButton from "../../components/Button/SaveButton";
    import InputEditor from "../../components/Input/InputEditor";
    import InputImageUpload from "../../components/Input/InputImageUpload";
    import {mapState} from "vuex";
    import DatePicker from "../../components/Input/DatePicker";
    import {permissionOurService, role} from "../../util/Permission";
    import Swal from "sweetalert";
    import CommandButton from "../../components/Layout/CommandButton";
    import SubmitButton from "../../components/Button/SubmitButton";
    import CreateOurServiceDetail from "./CreateOurServiceDetail";

    export default {
        name: "OurServiceEdit",
      components: {
        CreateOurServiceDetail,
        SubmitButton,
        CommandButton,
        DatePicker,
        InputImageUpload,
        InputEditor,
        SaveButton,
        PreviewButton, DeleteButton, InputTextField,
        SelectOption, LineHr, TitleEdit},
      computed: {
        permissionOurService,
        ...mapState({
          form: state => {
            return state.OurService.form;
          }
        })
      },
      data(){
        return{
          tab: 'st',
          subMenuTable: [],
          optionBranch : [],
          headers: [
            { id: 1, text: "No." },
            { id: 2, text: "Title TH" },
            { id: 3, text: "Title EN" },
            { id: 4, text: "Detail TH" },
            { id: 5, text: "Detail EN" },
            { id: 6, text: "Edit" }
          ],
          permission : null,
          dialog: false,
          save_id: null
        }
      },
      created() {
        this.permission = role;
        if (this.form.id) {
          this.getSubMenuTable(this.form.id);
        }
      },
      methods:{
        getSubMenuTable(id) {
          this.$store.dispatch("OurService/getOurServiceDetailFromServiceId", id).then(res => {
            this.subMenuTable = res;
          });
        },
        openSubMenu(id) {

          console.log(this.tab);
          if (id) {
            this.$store.dispatch("OurService/showOurServiceDetail", id).then(res => {
              if (res.response_code == 200) {
                this.$store.dispatch("OurService/setFormOurServiceDetail", res.result);
              } else {
                Swal(res.response_msg);
              }
            });
          } else {
            this.$store.dispatch("OurService/clearFormDetailData");
          }
          this.dialog = true;
          this.tab = 'nd'
          console.log(this.tab);
          // this.$router.push("/our-service/edit/detail#nd");
        },
        saveClose(){
          this.form.details = this.subMenuTable;
          if (!this.form.title_th) {
            Swal('','Please insert Title TH !','error');
          } else if (!this.form.title_en) {
            Swal('','Please insert Title EN !','error');
          } else if (!this.form.intro_th) {
            Swal('','Please insert Description TH !','error');
          } else if (!this.form.intro_en) {
            Swal('','Please insert Description EN !','error');
          } else if (!this.form.path) {
            Swal('','Please insert Path !','error');
          } else {
            this.$store
                    .dispatch("OurService/saveOurService", {
                      id: this.save_id ? this.save_id : this.form.id,
                      data: this.form
                    })
                    .then(res => {
                      Swal(res.response_msg);
                      if (res.response_code == 200) {
                        this.goToOurServiceTable();
                      }
                    })
                    .catch(() => {
                      Swal('', 'Cannot save Our Service data!', 'error');
                    });
          }
        },
        saveOurService(){
          this.form.details = this.subMenuTable;
          if (!this.form.title_th) {
            Swal('','Please insert Title TH !','error');
          } else if (!this.form.title_en) {
            Swal('','Please insert Title EN !','error');
          } else if (!this.form.intro_th) {
            Swal('','Please insert Description TH !','error');
          } else if (!this.form.intro_en) {
            Swal('','Please insert Description EN !','error');
          } else if (!this.form.path) {
            Swal('','Please insert Path !','error');
          } else {
            this.$store
                    .dispatch("OurService/saveOurService", {
                      id: this.save_id ? this.save_id : this.form.id,
                      data: this.form
                    })
                    .then(res => {
                      this.save_id = res.result.id;
                      Swal(res.response_msg);
                    })
                    .catch(() => {
                      Swal('', 'Cannot save Our Service data!', 'error');
                    });
          }
        },
        deleteOurService(){
          this.$store
            .dispatch("OurService/deleteOurService", this.form.id)
            .then(res => {
              Swal(res.response_msg);
              if (res.response_code == 200) {
                this.goToOurServiceTable();
              }
            })
            .catch(() => {
              Swal('','Cannot delete Our Service','error');
            });
        },
        updateImageIllust(val) {
          this.form.image_illustration = val.imagePath;
          this.form.image_illustration_show = val.fullImagePath;
        },
        updateImageCover(val) {
          this.form.image_cover = val.imagePath;
          this.form.image_cover_show = val.fullImagePath;
        },
        goToOurServiceTable(){
          this.$router.push("/our-service");
        },
        updateTitleTH(val){
          this.form.title_th = val;
        },
        updateTitleEN(val){
          this.form.title_en = val;
        },
        updateDescriptionTH(val){
          this.form.intro_th = val;
        },
        updateDescriptionEN(val){
          this.form.intro_en = val;
        },
        updateSlugUrl(val){
          this.form.slug_url = val;
        },
        updatePath(val){
          this.form.path = val;
        },
        saveSubMenuDetails(val) {
          this.dialog = false;
          this.tab = 'st'
            if(val){
              this.subMenuTable.push(val);
            }
          console.log(this.subMenuTable)
        },
        deleteSubMenu(id,index){
          if(id){
            this.$store.dispatch("OurService/deleteOurService",id).then(res=>{
              Swal(res.response_msg);
              if (res.response_code == 200){
                this.removeSubMenu(index);
              }
            }).catch(()=>{
              Swal('','Cannot delete our service','error');
            })
          }else{
            this.removeSubMenu(index);
          }
        },
        removeSubMenu(index){
          this.subMenuTable = this.subMenuTable.filter(
                  (detail, itemIndex) => index !== itemIndex
          );
        },
      }
    }
</script>

<style lang="scss" scoped>

</style>
